import { getAlmeSessionData } from '../../AlmeApp/AlmeAppSessionState';
import { TerminateLiveChat } from "../../LiveChat/AlmeLiveChatReportingEvents";
function createLoginParams(sessionId, cifId) {
    return {
        ClientSessionId: sessionId,
        UserObj: {
            cifId,
        },
        IsLoggedIn: true,
    };
}
function createLogoutParams(clientSessionId) {
    return {
        ClientSessionId: clientSessionId,
        IsLoggedIn: false,
        LaunchPointName: 'Logout',
        LaunchParameter: 'Logout',
        LaunchType: 'Manual',
        NewSessionReason: 'newSessionOnLogout',
    };
}
async function logoutEvent(almeApiUtils, clientSessionId) {
    var _a;
    await almeApiUtils.sendAppEvent("OnUserLogOut", undefined, {
        ClientSessionId: clientSessionId,
        IsLoggedIn: false,
    });
    await almeApiUtils.endConversation();
    almeApiUtils.createNewSessionData();
    await almeApiUtils.sendAppEvent('HostPageData', undefined, {
        PageInfo: window._SFDDL,
        AlmeUserID_PreLogin: (_a = getAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.userId,
    });
    return await almeApiUtils.sendAppEvent("WelcomeUser", undefined, createLogoutParams(clientSessionId));
}
export function getAccountId(almeState, sessionId, accountId) {
    if (almeState.sessionMessages
        && almeState.sessionMessages.sessionId
        && (almeState.sessionMessages.sessionId === sessionId)
        && almeState.sessionMessages.messages
        && almeState.sessionMessages.messages.SwitchAccount) {
        return almeState.sessionMessages.messages.SwitchAccount.accountId;
    }
    return accountId;
}
const updateUserLoggedInState = async (almeState, appConfig, almeApiUtils, userLogInState) => {
    var _a, _b;
    const hasPreviousConversation = almeState.hasPreviousConversation;
    if (appConfig.main.isLoggedIn || ((_a = appConfig.main.userMetadata) === null || _a === void 0 ? void 0 : _a.cifId)) {
        if (!hasPreviousConversation || !almeState.isLoggedIn) {
            userLogInState.isLoggedIn = true;
            userLogInState.loginStateResponse = await almeApiUtils.sendAppEvent("OnUserLogIn", undefined, createLoginParams(userLogInState.clientSessionId, (_b = appConfig.main.userMetadata) === null || _b === void 0 ? void 0 : _b.cifId));
        }
    }
    else {
        if (hasPreviousConversation && almeState.isLoggedIn) {
            await TerminateLiveChat(almeApiUtils, almeState);
            userLogInState.isLiveChatConnected = false;
            userLogInState.loginStateResponse = await logoutEvent(almeApiUtils, userLogInState.clientSessionId);
        }
        userLogInState.isLoggedIn = false;
    }
};
/**
 * @param almeApiUtils API utility
 * @param almeState App state
 * @returns User logged in state and response
 */
export async function sendLoginStateEvents(appConfig, almeApiUtils, almeState) {
    const userLogInState = { isLoggedIn: almeState.isLoggedIn, isLiveChatConnected: almeState.isLiveChatConnected };
    userLogInState.clientSessionId = appConfig.main.clientSessionId;
    await updateUserLoggedInState(almeState, appConfig, almeApiUtils, userLogInState);
    return userLogInState;
}
